import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route changes, EXCEPT when only the language prefix changed.
const stripLocale = (pathname) => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length > 0 && (parts[0] === "ar" || parts[0] === "en")) {
    return "/" + parts.slice(1).join("/");
  }
  return pathname;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const prev = window.__voryzix_prev_path;
    const currentStripped = stripLocale(pathname);
    const prevStripped = prev ? stripLocale(prev) : null;

    if (prevStripped !== currentStripped) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    window.__voryzix_prev_path = pathname;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
